import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scrolls to the top of the page when the route changes.
 * Place this component inside the Router to enable automatic scroll restoration.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
